var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 9.30762L13 16.6922L25 9.30762",
    stroke: "#8D90A5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.69238 11.6154V2.84615C4.69238 1.83077 5.52315 1 6.53854 1H19.4616C20.477 1 21.3078 1.83077 21.3078 2.84615V11.6154",
    stroke: "#8D90A5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3077 4.69238C23.3385 4.69238 25 6.35392 25 8.38469V21.3078C25 23.3385 23.3385 25.0001 21.3077 25.0001H4.69231C2.66154 25.0001 1 23.3385 1 21.3078V8.38469C1 6.35392 2.66154 4.69238 4.69231 4.69238",
    stroke: "#8D90A5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.38477 4.69238H14.8463",
    stroke: "#8D90A5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.38477 8.38477H11.154",
    stroke: "#8D90A5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTabIcon);
export default __webpack_public_path__ + "static/media/emailTabIcon.23d4297d4abb694cf4a4d49992212958.svg";
export { ForwardRef as ReactComponent };